import React, { FC } from "react"
import Button from "@components/Button"
import { scrollTo } from "@utils/scrollTo"
import { Link } from "gatsby"
import type { HeroProps } from "./types"
import {
    BackgroundImageWrapper,
    ContentWrapper,
    HeroWrapper,
    Overlay,
    Subtitle,
    Title,
    Description,
    ButtonWrapper,
    ViewMore,
    ViewMoreArrow
} from "./styles"

const Hero: FC<HeroProps> = ({
    title,
    subtitle,
    backgroundImage,
    buttons,
    description
}) => {
    return <HeroWrapper id="hero">
        <Overlay />
        {backgroundImage && <BackgroundImageWrapper>
            {backgroundImage}
        </BackgroundImageWrapper>}
        <ContentWrapper>
            {subtitle && <Subtitle>{subtitle}</Subtitle>}
            {title && <Title>{title}</Title>}
            {description && <Description dangerouslySetInnerHTML={{ __html: description }} />}
            {buttons && <ButtonWrapper>
                {buttons.map((button) => (
                    <Button
                        as={Link}
                        key={`${button?.link}_${button?.label}`}
                        href={button?.link}
                        color={button?.color}
                        outlined={button?.outlined}
                    >
                        {button?.label}
                    </Button>
                ))}
            </ButtonWrapper>}
        </ContentWrapper>
        <ViewMore onClick={() => scrollTo("hero")}>Bekijk meer</ViewMore>
        <ViewMoreArrow
            height={89}
            width={18}
            src="/icons/long-arrow-down.svg"
        />
    </HeroWrapper>
}

export default Hero
